import { render, staticRenderFns } from "./Delivered.vue?vue&type=template&id=f972f1a6&scoped=true&"
import script from "./Delivered.vue?vue&type=script&lang=js&"
export * from "./Delivered.vue?vue&type=script&lang=js&"
import style0 from "./Delivered.vue?vue&type=style&index=0&id=f972f1a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f972f1a6",
  null
  
)

export default component.exports